import logger from 'src/utils/logger/logger';
export default function detection(agent) {
  const comp_agent = (agent.indexOf('netrange') !== -1 || agent.indexOf('netrangemmh') !== -1) ;
  if (comp_agent) {
    logger.info('[netrange detection] detected');
  }
  return comp_agent;
}



// WEBPACK FOOTER //
// ./src/devices/netrange/detection.js